import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Card = styled.div<{ theme: Theme }>`
  .authors {
    line-height: 17px;
  }

  .date {
    line-height: 17px;
    letter-spacing: 0.15px;
  }

  // Style for ArticleCardSimple
  &.simple { 
    h4 {
      margin: 0 0 8px;
      text-align: left;
      letter-spacing: 0.15px;
    }
  }
`;

export const Title = styled(Heading)`
  text-align: center;
  margin: 0;
  color: inherit;

  @media (${breakpoint.mdMin}) {
    margin: 0 0 16px;
    text-align: left;
  }
`;
